import { useContext } from 'react';

import { CampaignsContext, CampaignsLoadingContext, SetCampaignsContext } from '../context';

export const useCampaigns = () => useContext(CampaignsContext)!;
export const useCampaignsLoading = () => useContext(CampaignsLoadingContext)!;
export const useSetCampaigns = () => useContext(SetCampaignsContext)!;